import axios from 'axios';

// Obtiene el puerto de la API de las variables de entorno, con un fallback
const apiPort = process.env.REACT_APP_API_PORT || 7001;

// Esta es la URL "Maestra" o "Por Defecto".
// Se usará para el login inicial y la validación de la sesión.
// export const DEFAULT_API_URL = window.location.hostname === "localhost" 
//     ? `${window.location.protocol}//localhost:${apiPort}` 
//     : `${window.location.protocol}//${window.location.hostname}`;

export const DEFAULT_API_URL = "http://localhost:7001";
// export const DEFAULT_API_URL = "https://api-sanfernando.carrefour.com.ar";
// Creamos la instancia de Axios
const api = axios.create({
    baseURL: DEFAULT_API_URL 
});

// --- ¡Aquí ocurre la magia! ---
// Este "interceptor" se ejecuta ANTES de CADA petición de API.
api.interceptors.request.use(
    (config) => {
        let sessionData;
        try {
            // 1. Lee la sesión completa desde localStorage
            sessionData = JSON.parse(localStorage.getItem('session'));
        } catch (e) {
            sessionData = null;
        }

        if (sessionData) {
            const { access_token, current_store } = sessionData;

            // 2. Adjunta el token de autenticación (si existe)
            if (access_token) {
                config.headers.Authorization = `Bearer ${access_token}`;
            }

            // 3. Si una tienda está seleccionada, reconfigura la petición
            if (current_store) {
                
                // 3a. ¡Sobrescribe la baseURL para apuntar a la API de la tienda correcta!
                // Usamos la URL que vino del login.
                config.baseURL = current_store.api_url; 
                
                // 3b. ¡Adjunta el X-Store-ID!
                config.headers['X-Store-ID'] = current_store.id;

            } else {
                // Si no hay tienda seleccionada (ej. justo después del login, o validando sesión), 
                // nos aseguramos de que use la URL por defecto.
                config.baseURL = DEFAULT_API_URL;
            }
        }
        
        return config;
    },
    (error) => Promise.reject(error)
);

export default api;